// Bir olay hedefinin, sayfa ağacının DIŞINA (document.body'ye) portal'lanmış bir katmanın
// içinde olup olmadığını söyler.
//
// NEDEN VAR: "dışarı tıklayınca kapan" kalıbı, panelin DOM alt ağacını `ref.contains(e.target)`
// ile sınar. AsyncGenericSelect (açılır liste), Tooltip ve MUI tarih seçicisi (Popper) kendi
// katmanlarını createPortal ile document.body'ye basar — yani mantıken panelin İÇİNDE, DOM'da
// DIŞINDA dururlar. Bu iki gerçek ayrışınca panel, kendi açılır listesine basılan ilk mousedown
// ile kapanır; kapanınca seçenek unmount olur ve tıklama (mousedown → mouseup → click sırasının
// son adımı) hiç işlemez. Puantaj üst şeridindeki KAPSAM paneli tam olarak böyle çalışmıyordu:
// hiçbir kapsam seçilemiyordu (bkz. pages/puantaj/PuantajScopePanel.test.js).
//
// Bu yüzden panel içeren her ekran, "dışarı" kararını verirken bu yardımcıyı da sormalıdır:
//   if (ref.current && !ref.current.contains(e.target) && !isInsidePortalLayer(e.target)) close();
const PORTAL_LAYER_SELECTOR = [
  '[data-portal-layer]',      // depo bileşenleri (AsyncGenericSelect, Tooltip)
  '.MuiPopper-root',          // MUI Popper (DateTimePicker takvimi)
  '.MuiPopover-root',
  '.MuiModal-root',
  '.MuiDialog-root',
].join(',');

export default function isInsidePortalLayer(target) {
  if (!target || typeof target.closest !== 'function') return false;
  return !!target.closest(PORTAL_LAYER_SELECTOR);
}
